import { NAV_LINKS } from "@/data";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-[#333]" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20">
          <div className="lg:col-span-6">
            <Logo markSize={34} textClassName="text-3xl text-white mb-6" className="mb-6" />
            <p className="font-mono font-light text-[#A3A3A3] max-w-sm text-base leading-relaxed">
              Precision scaffolding and heavy-civil temporary works. Engineered,
              erected and dismantled to a single, uncompromising standard.
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#555] mb-6">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="font-mono text-[#A3A3A3] hover:text-[#FF4D00] transition-colors text-sm">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#555] mb-6">Contact</p>
            <ul className="space-y-3 font-mono text-sm text-[#A3A3A3]">
              <li>build@cretexa.ca</li>
              <li>+1 (403) 555-0142</li>
              <li>Calgary, AB</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#333] pt-10 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#555]">
            © {new Date().getFullYear()} Cretexa — Proudly Canadian
          </p>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#555]">
            CSA Z797 / CSA S269 / Provincial OH&S Compliant
          </p>
        </div>

        <div className="mt-16 -mb-6 overflow-hidden" aria-hidden="true">
          <h2 className="font-display font-black uppercase tracking-tighter text-[18vw] leading-[0.75] text-[#1A1A1A] select-none">
            Cretexa
          </h2>
        </div>
      </div>
    </footer>
  );
}
